import React from 'react'
import { MenuBook } from '@mui/icons-material'
import theme from '../../theme/Default'

const SidebarIcon = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <MenuBook
        sx={{
          fontSize: 110,
          margin: 'auto',
          fill: theme.palette.background.main
        }}
      />
    </div>
  )
}

export default SidebarIcon
